import React from 'react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import './cfTippyTheme.css'

type Props = React.ComponentProps<typeof Tippy>

function Tooltip({
  placement = 'top-end',
  theme = 'cf-tippy',
  ...props
}: Props) {
  return <Tippy theme={theme} placement={placement} {...props} />
}

export default Tooltip
